// https://github.com/sindresorhus/titleize
import titleize from 'titleize'
export default titleize
